import { PayloadAction } from '../../../store.model';
import { createFocusTags } from '../function/create-behaviour-tags.function';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import {
    UpdateTranscript,
    UpdateTranscriptResult,
} from './update-transcript.action';

export function updateTranscriptReducer(
    state: TranscriptDialogState,
    _: PayloadAction<
        ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT,
        UpdateTranscript
    >,
): TranscriptDialogState {
    return {
        ...state,
        pending: {
            ...state.pending,
            updateTranscript: true,
        },
    };
}

export function updateTranscriptResultReducer(
    state: TranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT_RESULT,
        UpdateTranscriptResult
    >,
): TranscriptDialogState {
    const nextPrimaryFocusTag = createFocusTags(
        action.payload.transcript.focuses?.filter((e) => e.isPrimary === true),
        state.behaviours,
        state.subBehaviours,
    )?.[0];
    const nextBehaviourTags = createFocusTags(
        action.payload.transcript.focuses?.filter((e) => e.isPrimary !== true),
        state.behaviours,
        state.subBehaviours,
    );

    return {
        ...state,
        pending: {
            ...state.pending,
            updateTranscript: false,
        },
        transcript: {
            ...action.payload.transcript,
            name: action.payload.transcript.name,
            description: action.payload.transcript.description,
            focuses: action.payload.transcript.focuses,
            caResult: state.transcript.caResult,
            summary: state.transcript.summary,
        },
        primaryFocusTag: nextPrimaryFocusTag,
        behaviourTags: nextBehaviourTags,
        cmtNotesFocus: nextPrimaryFocusTag,
    };
}
